// assets/tiered-free-delivery-promos.js
if (!customElements.get('tiered-free-delivery-promos')) {
  class TieredFreeDeliveryPromos extends HTMLElement {
    constructor() {
      super();

      this.threshold = parseInt(this.getAttribute('threshold')) || 30000; // Shopify = cents
      this.bar = this.querySelector('.fsp-bar');
      this.message = this.querySelector('.fsp-message');

      this.updateProgress();
      this.observeCartUpdates();
    }

    observeCartUpdates() {
      // Listen for cart updates (Dawn triggers this on change)
      document.addEventListener('cart:updated', (e) => {
        this.updateProgress(e.detail?.cart);
      });

      // If inside cart drawer — handle open transitions
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.addEventListener('opening', () => this.updateProgress());
      }
    }

    async fetchCart() {
      const res = await fetch('/cart.js');
      return await res.json();
    }

    async updateProgress(cartData = null) {
      const cart = cartData || (await this.fetchCart());
      const total = cart.total_price; // in cents
      const percent = Math.min((total / this.threshold) * 100, 100);

      if (this.bar) {
        this.bar.style.width = `${percent}%`;
      }

      if (this.message) {
        if (total >= this.threshold) {
          this.message.innerHTML =
            '<strong>Congratulations!</strong> You’ve unlocked free shipping 🎉';
        } else {
          const remaining = ((this.threshold - total) / 100).toFixed(2);
          this.message.innerHTML = `You’re $${remaining} away from <strong>free shipping</strong>.`;
        }
      }
    }
  }

  customElements.define('tiered-free-delivery-promos', TieredFreeDeliveryPromos);
}
